import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { adminListExports, adminCreateExport, adminDownloadExport } from "@/lib/api";
import { Download, DatabaseBackup } from "lucide-react";
import { toast } from "sonner";

export default function AdminExport() {
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => adminListExports().then(setFiles).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    setBusy(true);
    try { const r = await adminCreateExport(); toast.success(`Backup created: ${r.filename}`); load(); }
    catch { toast.error("Export failed"); } finally { setBusy(false); }
  };

  return (
    <AdminLayout>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <h1 className="rbl-h1" style={{ fontSize: 34 }}>Data export</h1>
        <button className="rbl-btn" onClick={create} disabled={busy} data-testid="create-export">
          <DatabaseBackup size={16} /> {busy ? "Creating backup…" : "Create new backup"}
        </button>
      </div>
      <p className="rbl-intro">Full backup of all MongoDB collections as a downloadable ZIP (admin-only). Use it to migrate or restore.</p>
      <div style={{ marginTop: 18 }} data-testid="export-list">
        {files.length === 0 && <p style={{ color: "var(--muted)" }}>No backups yet — create one above.</p>}
        {files.map((f) => (
          <div key={f.filename} className="rbl-list-item">
            <div>
              <div style={{ fontWeight: 700 }}>{f.filename}</div>
              <div style={{ color: "var(--muted)", fontSize: 13 }}>{f.size_mb} MB · {new Date(f.created_at).toLocaleString()}</div>
            </div>
            <button className="rbl-icon-btn" data-testid={`dl-${f.filename}`} onClick={() => adminDownloadExport(f.filename)}><Download size={18} /></button>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
